import React from 'react'
import { Link } from 'react-router-dom'
import { CheckCircleIcon, ShoppingBagIcon, ArrowRightIcon, ClockIcon, EnvelopeIcon, PhoneIcon, TruckIcon } from '@heroicons/react/24/outline'
import { motion } from 'framer-motion'

const OrderConfirmation = () => {
  const orderNumber = `TW-${Math.random().toString(36).substr(2, 9).toUpperCase()}`

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-16">
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-3xl shadow-xl border border-gray-100 p-10 max-w-lg w-full text-center"
      >
        {/* Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: 'spring', stiffness: 200 }}
          className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <CheckCircleIcon className="w-10 h-10 text-green-500" />
        </motion.div>

        <h1 className="text-2xl font-extrabold text-gray-900 mb-2">Order Placed Successfully!</h1>
        <p className="text-gray-500 text-sm leading-relaxed mb-6">
          Thank you for your order. We've received your request and our team will confirm it within <strong>24–48 hours</strong>.
        </p>

        {/* Order Number */}
        <div className="bg-primary-50 border border-primary-100 rounded-2xl px-6 py-4 mb-6 inline-block w-full">
          <p className="text-xs text-primary-500 font-semibold uppercase tracking-wide mb-1">Order Number</p>
          <p className="text-xl font-extrabold text-primary-700 font-mono">{orderNumber}</p>
        </div>

        {/* What's next */}
        <div className="text-left bg-gray-50 rounded-2xl p-5 mb-7">
          <h3 className="font-bold text-gray-900 text-sm mb-3">What Happens Next?</h3>
          <ol className="space-y-3">
            {[
              { icon: <EnvelopeIcon className="w-5 h-5 text-primary-600" />, text: 'A confirmation email will be sent to your inbox with full order details.' },
              { icon: <PhoneIcon className="w-5 h-5 text-primary-600" />, text: 'Our team will review your order and reach out within 24–48 hours to confirm.' },
              { icon: <TruckIcon className="w-5 h-5 text-primary-600" />, text: 'Your order will be shipped within 3–4 weeks from confirmation.' },
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-gray-600">
                <span className="mt-0.5 flex-shrink-0">{item.icon}</span>
                {item.text}
              </li>
            ))}
          </ol>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/shop"
            id="order-confirm-shop-btn"
            className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-colors text-sm"
          >
            <ShoppingBagIcon className="w-4 h-4" />
            Continue Shopping
          </Link>
          <Link
            to="/contact"
            id="order-confirm-contact-btn"
            className="flex-1 flex items-center justify-center gap-2 px-6 py-3 border-2 border-gray-200 text-gray-700 hover:border-primary-300 hover:text-primary-700 font-semibold rounded-xl transition-colors text-sm"
          >
            Contact Us
            <ArrowRightIcon className="w-4 h-4" />
          </Link>
        </div>

        <p className="text-xs text-gray-400 mt-5">
          Questions? Email us at <a href="mailto:twiggleoralcare@gmail.com" className="text-primary-600 underline">twiggleoralcare@gmail.com</a>
        </p>
      </motion.div>
    </div>
  )
}

export default OrderConfirmation
